/**
 * Product event names, defined once (docs/engineering/observability.md). Renaming one breaks dashboards —
 * treat it like an API change. Properties must never carry personal data.
 *
 * These are the owner actions no server query can see. They are consent-gated, so they show behaviour
 * rather than exact counts; the first-booking funnel itself is computed from the database
 * (docs/business/metrics.md).
 */
export const PRODUCT_EVENTS = {
  /** `{ channel: "link" | "meta" | "google" }` */
  bookingLinkCopied: "booking_link_copied",
  /** `{ format: "png" | "svg" }` */
  bookingQrDownloaded: "booking_qr_downloaded",
  bookingQrPrinted: "booking_qr_printed",
  /** `{ reason: "NO_HOURS" | "NO_ONLINE_SERVICE" | "ONLINE_BOOKING_OFF" }` */
  goLiveNoHoursWarned: "go_live_no_hours_warned",
  /** `{ reason: "NO_HOURS" | "NO_ONLINE_SERVICE" | "ONLINE_BOOKING_OFF" }` */
  goLiveNoHoursContinued: "go_live_no_hours_continued",
} as const;
